import { useEffect, useState } from "react";
import { Activity as ActivityIcon } from "lucide-react";
import { api } from "../../lib/api";

export default function Actividad() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/ejecutivo/activity").then((r) => setItems(r.data || []));
    }, []);

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="actividad-page">
            <h1 className="text-3xl font-semibold mb-1 inline-flex items-center gap-2">
                <ActivityIcon size={26} className="text-edu-navy" /> Actividad de Plataforma
            </h1>
            <p className="text-edu-body mb-6">Acciones recientes en toda la plataforma.</p>

            <div className="edu-card divide-y divide-edu/50">
                {items.length === 0 && <p className="p-6 text-edu-muted">Sin actividad registrada.</p>}
                {items.map((a, i) => (
                    <div key={i} className="flex items-center justify-between p-4">
                        <div>
                            <div className="text-sm font-medium">{a.description}</div>
                            <div className="text-xs text-edu-muted capitalize">{a.kind}</div>
                        </div>
                        <span className="text-xs text-edu-muted">{(a.created_at || "").slice(0, 16).replace("T", " ")}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
